import { useNavigatorLanguage } from '@vueuse/core';

const { language } = useNavigatorLanguage();

// How to configure: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
export function useHFormatDateTime(
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
  localeTransforms: Record<string, Function> = {},
) {
  function formatDate(dateString: string) {
    if (!dateString) return '';

    const locale = language.value;
    const _options = { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, ...options };

    let formattedDate = Intl.DateTimeFormat(locale, _options).format(new Date(dateString));
    const parsedLocale = locale?.toLowerCase();

    if (parsedLocale) {
      formattedDate = localeTransforms[parsedLocale]?.(formattedDate) ?? formattedDate;
    }

    return formattedDate;
  }

  return { formatDate };
}
